// assets/cc-nav.js

(function () {
  const nav = document.querySelector('.cc-nav');

  if (!nav) return;
  if (nav.dataset.navInit) return;

  nav.dataset.navInit = '1';

  // Scroll shrink
  const onScroll = () => {
    nav.classList.toggle('cc-nav--scrolled', window.scrollY > 60);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Mobile overlay
  const overlay = document.querySelector('.cc-nav-overlay');
  const hamburger = document.querySelector('.cc-nav__hamburger');

  if (hamburger && overlay) {
    const focusableSelectors =
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const trapFocus = (e) => {
      const focusable = Array.from(
        overlay.querySelectorAll(focusableSelectors)
      );

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.key === 'Tab') {
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      if (e.key === 'Escape') {
        close();
      }
    };

    const open = () => {
      overlay.classList.add('cc-nav-overlay--open');
      nav.classList.add('cc-nav--open');
      document.body.classList.add('cc-nav-menu-open');

      hamburger.setAttribute('aria-expanded', 'true');
      hamburger.classList.add('cc-nav__hamburger--open');

      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';

      const firstFocusable = overlay.querySelector(focusableSelectors);

      if (firstFocusable) {
        firstFocusable.focus();
      }

      document.addEventListener('keydown', trapFocus);
    };

    const close = () => {
      overlay.classList.remove('cc-nav-overlay--open');
      nav.classList.remove('cc-nav--open');
      document.body.classList.remove('cc-nav-menu-open');

      hamburger.classList.remove('cc-nav__hamburger--open');
      hamburger.setAttribute('aria-expanded', 'false');

      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';

      document.removeEventListener('keydown', trapFocus);
    };

    // Toggle overlay with hamburger
    hamburger.addEventListener('click', () => {
      if (overlay.classList.contains('cc-nav-overlay--open')) {
        close();
      } else {
        open();
      }
    });

    // Close when clicking outside overlay
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        close();
      }
    });

    // Close when clicking nav links
    overlay.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', close);
    });
  }

  // Cart count bubble
  const updateCartCount = (count) => {
    document.querySelectorAll('.cc-nav__cart-count').forEach((el) => {
      el.textContent = count;
      el.dataset.count = count;
    });
  };

  fetch('/cart.js')
    .then((r) => r.json())
    .then((d) => updateCartCount(d.item_count))
    .catch(() => {});

  if (typeof subscribe !== 'undefined') {
    subscribe('cart-update', (event) => {
      updateCartCount(event.cartData?.item_count ?? 0);
    });
  }
})();